import Main from './main';

export default function App(): JSX.Element {
  return <Main />;
}
